import React from "react";
import { FilterList } from '../Filters';
import { FilterMenuTrigger } from "~/ui/TableActionBar/FilterMenu";

export const SubViewContext = React.createContext({ showFilters: false });

export const SubViewContextProvider = (props) => {
    const [ showFilters, setShowFilters ] = React.useState(false);
    const toggleFitlers = React.useCallback(() => setShowFilters((showFilters) => !showFilters), []);

    return <SubViewContext.Provider { ...props } value={{ toggleFitlers, showFilters }} />
}


export const ShowFilterMenuButton = (props) => {
    const {toggleFitlers} = React.useContext(SubViewContext);
    return <FilterMenuTrigger {...props} onPress={toggleFitlers} />
}

export const FilterMenuList = (props) => {
    const {showFilters} = React.useContext(SubViewContext);
    if (!showFilters) return null;

    return <FilterList {...props} />
}